(function () {
  angular
    .module('kareo.ui.shared.modules.api.patient-service', [
        'kareo.ui.shared.directives.k-edit-patient.private.billing-profile-types'
    ])
    .factory('patientService', patientService);

  patientService.$inject = ['$cacheFactory', '$http', '$q', 'BILLING_PROFILE_TYPES'];
  function patientService($cacheFactory, $http, $q, BILLING_PROFILE_TYPES) {
    var patientApiURL = '/patient-mgmt-ui/api/Patient';
    var commonPatientApiUrl = '/common-ui/api/Patient';
    var dataApiURL = '/patient-mgmt-ui/api/Data';
    var httpCache = $cacheFactory.get('$http');

    var svc = {};

    svc.checkDuplicatePatients = checkDuplicatePatients;
    svc.createPatient = createPatient;
    svc.getGenders = getGenders;
    svc.getPatientAddresses = getPatientAddresses;
    svc.getActivePatientIntakeByPatientGuid = getActivePatientIntakeByPatientGuid;
    svc.getPatientByGuid = getPatientByGuid;
    svc.getPatientPreferredAddress = getPatientPreferredAddress;
    svc.getPatientWithPreferredAddress = getPatientWithPreferredAddress;
    svc.getStates = getStates;
    svc.updatePatient = updatePatient;

    return svc;

    //---------------------------------------------------------------------------

    function checkDuplicatePatients(p, resolveToCancel) {
      return getDuplicatePatientsWithPreferredAddresses(p, resolveToCancel);
    }

    function createPatient(p) {
      var patient = saveablePatient(p);
      return $http
        .post(patientApiURL, patient)
        .then((response) => {
          // At some point we might want to check exactly what
          // comes back from the response.
          return response.data;
        });
    }

    function getGenders() {
      return $http
        .get(dataApiURL + '/genders', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }

    async function getActivePatientIntakeByPatientGuid(patientGuid) {
      const response = await $http
        .get('/patient-intake-ui/api/PatientIntake', {
          params: {
            isExpired: false,
            limit: 1,
            patientGuids: [patientGuid],
            skip: 0,
            statuses: ['NOT_SUBMITTED']
          }
        });

      if (!response || !response.data) {
        return null;
      }

      const {
        results
      } = response.data;

      if (!results || !results.length) {
        return null;
      }

      return results[0];
    }

    function getPatientAddresses(patientId, resolveToCancel) {
      return $http
        .get(getPatientAddressesUrl(patientId), {
          cache: true,
          timeout: resolveToCancel
        })
        .then((response) => {
          return response.data;
        });
    }

    function getPatientPreferredAddress(patientId, resolveToCancel) {
      return svc.getPatientAddresses(patientId, resolveToCancel)
        .then((addresses) => {
          var address,
i;

          if (Array.isArray(addresses)) {
            for (i = 0; i < addresses.length; i++) {
              address = addresses[i];
              if (address.preferred) {
                return address;
              }
            }
          }

          return null;
        });
    }

    function getPatientByGuid(guid) {
      if (!guid) {
        return $q.reject('Invalid guid');
      }

      return $http
        .get(getPatientUrl(guid), {
          cache: true
        })
        .then((response) => {
          return response.data;
        }, (response) => {
          return $q.reject(response.data);
        });
    }

    function getPatientWithPreferredAddress(patientGuid) {
      return svc.getPatientByGuid(patientGuid)
        .then((patient) => {
          var patientId, preferredAddressPromise;
          patientId = patient.patientId;

          preferredAddressPromise = svc.getPatientPreferredAddress(patientId);

          return $q.all({
            patient,
            preferredAddress: preferredAddressPromise
          });
        })
        .then((results) => {
          var patient, preferredAddress;

          patient = results.patient;
          preferredAddress = results.preferredAddress;
          patient.address = preferredAddress;
          return patient;
        });
    }

    function getStates() {
      return $http
        .get(dataApiURL + '/states', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }

    function updatePatient(p) {
      var patient = saveablePatient(p);
      return $http.put(patientApiURL, patient).then((response) => {
        // invalidate cache
        if (!!patient.guid) {
          httpCache.remove(getPatientUrl(patient.guid));
        }

        if (!!patient.patientId) {
          httpCache.remove(getPatientAddressesUrl(patient.patientId));
        }

        // At some point we might want to check exactly what
        // comes back from the response.
        return response.data;
      });
    }

    // ----------------------------------------------------------------------

    /*
     * THIS FUNCTION IS TECH DEBT:
     * We really should be given the preferred address with the patient
     * via the webapp, but since we aren't, this builds the patient
     * preferred addresses prior to resolving. -Russell
     * */
    function getDuplicatePatientsWithPreferredAddresses(p, resolveToCancel) {
      var addressesByStateId, duplicateById, duplicatePatients;

      return realCheckDuplicatePatients(p, resolveToCancel)
        .then((duplicates) => {
          var addressPromises = {};

          duplicatePatients = duplicates;

          addressesByStateId = {};
          duplicateById = {};

          angular.forEach(duplicates, (duplicate) => {
            var patientId = duplicate.patientId, promise;

            duplicateById[patientId] = duplicate;

            promise = svc.getPatientAddresses(patientId,
              resolveToCancel);

            addressPromises[patientId] = promise;
          });

          return $q.all(addressPromises);
        }).then((addressesPerPatient) => {
          var address, addressesThisPatient, duplicatePatient, duplicatePatientId, i;

          for (duplicatePatientId in addressesPerPatient) {
            if (!addressesPerPatient.hasOwnProperty(duplicatePatientId) || !duplicateById.hasOwnProperty(duplicatePatientId)) {
              continue;
            }

            addressesThisPatient = addressesPerPatient[duplicatePatientId];
            duplicatePatient = duplicateById[duplicatePatientId];

            if (!Array.isArray(addressesThisPatient)) {
              continue;
            }

            /*
             * There is an unwritten guarantee that there is never more than
             * 2 addresses per patient, so the below loop can be considered
             * constant time
             * */

            address = null;
            for (i = 0; i < addressesThisPatient.length; i++) {
              address = addressesThisPatient[i];
              if (typeof address === 'object' && address.preferred) {
                if (!addressesByStateId.hasOwnProperty(address.stateId)) {
                  addressesByStateId[address.stateId] = [];
                }

                addressesByStateId[address.stateId].push(address);

                break;
              } else {
                address = null;
              }
            }

            duplicatePatient.address = address;
          }

          return svc.getStates();
        }).then((states) => {
          /*
           * There are only 50 states, even if other territories are included
           * these loops still run in constant time, worst case scenario is
           * 50^2 = 2500 iterations
           */
          angular.forEach(states, (state) => {
            var addresses, stateId;

            stateId = state.stateId;

            if (addressesByStateId.hasOwnProperty(stateId)) {
              addresses = addressesByStateId[stateId];

              angular.forEach(addresses, (address) => {
                address.state = state;
              });
            }
          });

          return $q.when(duplicatePatients);
        }, (response) => {
          return response.data;
        });
    }

    function getPatientUrl(guid) {
      return commonPatientApiUrl + '/' + guid;
    }

    function getPatientAddressesUrl(patientId) {
      return patientApiURL + '/' + patientId + '/Addresses';
    }

    function isEmptyOrInvalidObject(obj) {
      return typeof obj !== 'object' || JSON.stringify(obj) === '{}';
    }

    // This function is also tech debt, was pulled down here to preserve
    // existing checkDuplicatePatients API
    function realCheckDuplicatePatients(p, resolveToCancel) {
      // modify the patient data to only submit things we will check for duplicates on
      var patient;
      patient = saveablePatient(p);

      return $http
        .get(patientApiURL + '/checkDuplicates', {
          cache: true,
          params: patient,
          timeout: resolveToCancel
        })
        .then((response) => {
          return response.data;
        });
    }

    function saveablePatient(sourcePatient) {
      var patient = angular.copy(sourcePatient);

      if (!!sourcePatient.name && !patient.firstName && !patient.lastName) {
        patient.firstName = sourcePatient.name.firstName;
        patient.lastName = sourcePatient.name.lastName;
      }
      if (typeof (sourcePatient.dateOfBirth) === 'string') {
        if (sourcePatient.dateOfBirth) {
          var month = sourcePatient.dateOfBirth.substring(0, 2);
          var day = sourcePatient.dateOfBirth.substring(2, 4);
          var year = sourcePatient.dateOfBirth.substring(4, 9);
          patient.dateOfBirth = new Date(year, month - 1, day).getTime();
        }
      } else if (isNaN(sourcePatient.dateOfBirth)) {
        patient.dateOfBirth = null;
      }

      if (isEmptyOrInvalidObject(patient.address)) {
        patient.address = null;
      } else if (typeof patient.address.state === 'object') {
        patient.address.stateId = patient.address.state.stateId;
      }

      if (patient.insurance === BILLING_PROFILE_TYPES.SELF_PAY) {
        patient.insurance = { selfPay: true };
      } else if (isEmptyOrInvalidObject(patient.insurance)) {
        patient.insurance = null;
      }

      return patient;
    }
  }
})();
